import React from 'react';
import { List, ListItemButton, ListItemIcon, ListItemText, Popover, Tooltip, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTasks } from '@fortawesome/pro-light-svg-icons';

export interface IStartPageTableFilter {
  id: string;
  label: string;
  description: string;
}

interface IStartPageTableFilterChooserProps {
  filters: IStartPageTableFilter[];
  anchorEl: HTMLButtonElement | null;
  onChange: (filterId: string) => void;
  onClose: () => void;
}

export function StartPageTableFilterChooser(props: IStartPageTableFilterChooserProps) {
  const { filters, anchorEl, onChange, onClose } = props;

  return (
    <Popover
      anchorEl={anchorEl}
      open={!!anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
    >
      <List component="nav" sx={{ width: 380 }}>
        {filters.map(filter => (
          <ListItemButton key={filter.id} onClick={() => onChange(filter.id)} aria-label={filter.label}>
            <ListItemIcon sx={{ minWidth: '30px' }}>
              <FontAwesomeIcon icon={faTasks} size="sm" />
            </ListItemIcon>
            <Tooltip
              enterNextDelay={400}
              title={
                <span>
                  <p>{filter.label}</p>
                  <p>{filter.description}</p>
                </span>
              }
              disableInteractive
            >
              <ListItemText disableTypography primary={<Typography sx={{ fontSize: '0.8571428571428571rem' }}>{filter.label}</Typography>} />
            </Tooltip>
          </ListItemButton>
        ))}
      </List>
    </Popover>
  );
}
